/**
 * Created by Yair on 25/12/2016.
 */
 export default function isLocalStorageSupported() {
    var testKey = 'test', storage = window.localStorage;
    try {
        storage.setItem(testKey, '1');
        storage.removeItem(testKey);
        return true;
    } catch (error) {
        return false;
    }
}


